import orderBy from "lodash/orderBy";
import { useMemo } from "react";

import { ESortDirection, useFormikField, TAutocomplete } from "Shared";

import { FormikAutocompleteMultipleComponent } from "./index";

export type FormikMultipleAutocompleteProps = Omit<
  TAutocomplete,
  "handleChange" | "onBlur" | "autocomplete" | "autocompleteValue"
>;

export const FormikAutocompleteMultiple = (
  props: FormikMultipleAutocompleteProps
) => {
  const { options, sort, name } = props;
  const formikPassedProps = useFormikField<string[]>(name);

  const sortedOptions = useMemo(
    () =>
      orderBy(
        options,
        [(option) => (sort ? sort(option) : option.label)],
        ESortDirection.ASC
      ),
    [options, sort]
  );

  const passedProps = {
    ...props,
    options: sortedOptions
  };

  return (
    <FormikAutocompleteMultipleComponent
      {...formikPassedProps}
      {...passedProps}
    />
  );
};
